<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { useMap } from '../mapbox/context'
import { onBeforeMount, onUnmounted, provide, watch } from 'vue'

const { map } = useMap()

const props = withDefaults(
  defineProps<{
    sourceId: string
    url?: string
  }>(),
  { url: '' },
)

const setSourceUrl = (url?: string) => {
  const source = map.value.getSource(props.sourceId)
  if (source && source.type === 'vector' && url) {
    source.setUrl(url)
  } else {
    map.value.addSource(props.sourceId, {
      type: 'vector',
      url: url,
    })
  }
}

onBeforeMount(() => {
  setSourceUrl(props.url)
})

watch(() => props.url, setSourceUrl)

onUnmounted(() => {
  map.value.removeSource(props.sourceId)
})

provide('source', props.sourceId)
</script>
